/**
 * Vocabulário compartilhado da tela de cobranças: rótulo e cor de cada valor cru que vem do banco.
 *
 * Fonte única do grid, dos filtros e dos chips — o filtro e a coluna precisam falar a mesma língua.
 * Os valores são os que `Cobranca::mapEfiStatus` grava, mais os que existem de fato na base
 * histórica (`pix` e `banking_billet` em forma de pagamento, `pendente` em status), que não estão
 * nas constantes do model mas aparecem em linhas antigas.
 */

export const STATUS_COBRANCA = [
    { value: 'pago', text: 'Pago', cor: 'green' },
    { value: 'settled', text: 'Pago manual', cor: 'teal' },
    { value: 'new', text: 'Novo', cor: 'blue-grey' },
    { value: 'waiting', text: 'Aguardando', cor: 'blue' },
    { value: 'pendente', text: 'Pendente', cor: 'blue lighten-1' },
    { value: 'identified', text: 'Identificado', cor: 'indigo' },
    { value: 'unpaid', text: 'Vencido', cor: 'red' },
    { value: 'contested', text: 'Contestado', cor: 'deep-orange' },
    { value: 'refunded', text: 'Reembolsado', cor: 'purple' },
    { value: 'estornado', text: 'Estornado', cor: 'purple darken-2' },
    { value: 'canceled', text: 'Cancelado', cor: 'grey' },
];

export const ATALHOS_STATUS = [
    { text: 'Pagas', icone: 'mdi-check-circle-outline', valores: ['pago', 'settled'] },
    { text: 'Em aberto', icone: 'mdi-clock-outline', valores: ['new', 'waiting', 'pendente'] },
    { text: 'Vencidas', icone: 'mdi-alert-circle-outline', valores: ['unpaid'] },
];

export const FORMAS_PAGAMENTO = [
    { value: 'pix', text: 'PIX' },
    { value: 'cartao', text: 'Cartão' },
    { value: 'bolix', text: 'Boleto/PIX' },
    { value: 'banking_billet', text: 'Boleto' },
];

export const GATEWAYS = [
    { value: 'gerencianet', text: 'Gerencianet' },
    { value: 'efi', text: 'EFI' },
];

export const STATUS_ASSINATURA = [
    { value: 'ativo', text: 'Ativa' },
    { value: 'cancelado', text: 'Cancelada' },
    { value: 'cancelamento', text: 'Em cancelamento' },
];

export const PERIODICIDADES = [
    { value: 'mensal', text: 'Mensal' },
    { value: 'anual', text: 'Anual' },
];

export const SITUACAO_EMPRESA = [
    { value: 'ativa', text: 'Ativa' },
    { value: 'inativa', text: 'Inativa' },
];

export const NOTA_FISCAL = [
    { value: 'com', text: 'Com nota' },
    { value: 'sem', text: 'Sem nota' },
    { value: 'cancelada', text: 'Nota cancelada' },
];

export const SIM_NAO = [
    { value: 'sim', text: 'Sim' },
    { value: 'nao', text: 'Não' },
];

export const CAMPOS_DATA_COBRANCA = [
    { value: 'vencimento', text: 'Vencimento' },
    { value: 'paid_at', text: 'Pagamento' },
    { value: 'created_at', text: 'Emissão' },
];

export const CAMPOS_DATA_TAXA = [
    { value: 'paid_at', text: 'Pagamento' },
    { value: 'created_at', text: 'Registro' },
];

export const METODOS_MP = [
    { value: 'pix', text: 'PIX' },
    { value: 'credito', text: 'Crédito' },
    { value: 'debito', text: 'Débito' },
];

export const CONTAS_MP = [
    { value: 'pf', text: 'PF (antiga)' },
    { value: 'pj', text: 'PJ' },
];

export const AGRUPAMENTOS_TAXA = [
    { value: '', text: 'Transação (sem agrupar)' },
    { value: 'empresa', text: 'Empresa' },
    { value: 'dia', text: 'Dia' },
    { value: 'mes', text: 'Mês' },
    { value: 'conta', text: 'Conta (PF/PJ)' },
];

function buscar(lista, valor) {
    return lista.find(i => i.value === valor);
}

export function rotuloDe(lista, valor) {
    if (valor === null || valor === undefined || valor === '') {
        return '';
    }

    const item = buscar(lista, valor);

    return item ? item.text : valor;
}

export function rotuloStatus(valor) {
    return rotuloDe(STATUS_COBRANCA, valor);
}

export function corStatus(valor) {
    const item = buscar(STATUS_COBRANCA, valor);

    return item ? item.cor : 'grey darken-1';
}
